import React, { Component } from 'react'
import moment from 'moment'
import IconComponent from '@modules/core/icons/IconComponent'
import TimeField from 'react-simple-timefield'

export class TimeInput extends Component {
  static defaultProps = {
    input: {
      value: undefined,
      onChange: () => undefined,
    },
  }

  onTimeChange = (newValue) => {
    const { value, onChange } = this.props.input

    const [hour, min] = newValue.split(':')

    onChange(moment(value).hour(hour).minute(min).toDate())
  }

  onIncrementMinutes = () => {
    const { value, onChange } = this.props.input
    onChange(moment(value).add(5, 'minutes').toDate())
  }

  onDecrementMinutes = () => {
    const { value, onChange } = this.props.input
    onChange(moment(value).add(-5, 'minutes').toDate())
  }

  render() {
    const { value } = this.props.input
    return (
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', width: 140 }}>
        <IconComponent icon="minus-circle" className="minus-circle" onClick={this.onDecrementMinutes} />
        <TimeField style={{ width: 90 }} value={value && moment(value).format('HH:mm')} onChange={this.onTimeChange} />
        <IconComponent icon="plus-circle" className="plus-circle" onClick={this.onIncrementMinutes} />
      </div>
    )
  }
}
